import React from 'react'
import ServiceItem from './ServiceItem'

import SwiperCore, {
  Navigation, Pagination, Scrollbar, A11y, Thumbs, Lazy, Zoom, Autoplay
} from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

SwiperCore.use([
  Navigation, Pagination, Scrollbar, A11y, Thumbs, Lazy, Zoom, Autoplay
])

export default function ServiceListSlider({
  appProps, itemsPerRow, sliderSettings, services, servicesPerRowClass
}) {
  const { arrows, dots, scrollbar, loop, autoMove, moveDuration } = sliderSettings

  return (
    <Swiper
      effect='slide'
      navigation={ !!arrows }
      pagination={ !!dots && { clickable: true } }
      scrollbar={ !!scrollbar && { draggable: true } }
      loop={ !!loop }
      autoplay={ !!autoMove && moveDuration && { delay: moveDuration * 1000 } }
      slidesPerView={ itemsPerRow || itemsPerRow }
      spaceBetween={ 10 }
      style={{ height: '100%', width: '100%' }}
      breakpoints={{
        0: { slidesPerView: 1 },
        500: { slidesPerView: itemsPerRow == 1 ? 1 : 2 },
        640: { slidesPerView: itemsPerRow == 1 ? 1 : 3 },
        768: { slidesPerView: itemsPerRow == 1 ? 1 : (itemsPerRow == (6 || 5 || 4) ? 3 : itemsPerRow) },
        900: { slidesPerView: itemsPerRow == 1 ? 1 : (itemsPerRow == (6 || 5) ? 4 : itemsPerRow) },
        1080: { slidesPerView: itemsPerRow == 1 ? 1 : (itemsPerRow == (6 || 5) ? 5 : itemsPerRow) },
        1280: { slidesPerView: itemsPerRow == 1 ? 1 : itemsPerRow }
      }}
    >
      { services.map( service => (
        <SwiperSlide key={ service.id }>
          <ServiceItem
            appProps={ appProps }
            service={ service }
            servicesPerRowClass={ servicesPerRowClass }
            serviceListStyle='overlay-style'
            isOnSlider
          />
        </SwiperSlide>
      ))}
    </Swiper>
  )
}
